import React, {useState, useContext} from 'react'
import { NotificationManager } from 'react-notifications';
import { Link } from 'react-router-dom'
import { backendService } from '../../services/backendService'
import { Icon, Table, Popup, Button, Modal, Form } from 'semantic-ui-react'
import DeleteModal from './deleteUserModal'
import { Text, Translate, LanguageContext } from '../../helpers/language';

const UsersTableRow = (props) => {
    const languageContext = useContext(LanguageContext);
    const { user, getUsers } = props;
    const [openModal, setOpenModal] = useState(false)
    const [openRefreshModal, setOpenRefreshModal] = useState(false)
    const [queries, setQueries] = useState(null)

    const dateLicense = new Date(user.license_expire_at)
    const dateCreated = new Date(user.createdAt)
    const licenseExpire = dateLicense.toLocaleString(languageContext.language.id, { year: 'numeric', month: 'long', day: 'numeric'} );
    const userCreated = dateCreated.toLocaleString(languageContext.language.id, { year: 'numeric', month: 'long', day: 'numeric'} );
    
    const handleDelete = async () => {
        try{
            await backendService.delete(`/api/lawyers/${user.id}`)
            NotificationManager.success(Translate(languageContext, 'user_profile_deleted'));
            getUsers();
        }
        catch(err){
            NotificationManager.error(Translate(languageContext, 'error') + ': ' + err.data);
        }
    }

    const handleRefreshQueries = async (quer) => {
        if (quer === null) await backendService.post(`/api/users/query/${user.email}/0`) 
        else await backendService.post(`/api/users/query/${user.email}/${quer}`)
        setQueries(null)
        setOpenRefreshModal(!openRefreshModal)
    }

    const handleChangeQueries = (e) => {
        setQueries(e.target.value)
    }

    return (
        <>
            <Table.Row>
                <Table.Cell className="center aligned">
                    {user.name}
                </Table.Cell>
                <Table.Cell className="center aligned">
                    {user.surname}
                </Table.Cell>
                <Table.Cell className="center aligned">
                    {user.email}
                </Table.Cell>
                <Table.Cell className="center aligned">
                    {user.is_verified ? <Text tid='user_email_verified' /> : <Text tid='user_email_not_verified' />}
                </Table.Cell>
                <Table.Cell className="center aligned">
                    {licenseExpire}
                </Table.Cell>
                <Table.Cell className="center aligned">
                    {userCreated}
                </Table.Cell>
                <Table.Cell style={{ display: 'flex', justifyContent:'space-around'}}>
                    <Popup content={<Text tid='user_profile_refresh_queries' />} trigger={
                        <Icon 
                            className='refresh alternate' 
                            style={{cursor: 'pointer'}}
                            onClick={() => setOpenRefreshModal(!openRefreshModal)}
                        />
                    } />

                    <Popup content={<Text tid='user_profile_edit_profile' />} trigger={
                        <Link to={`/edituser/${user.id}`} style={{color: 'black'}}>
                            <Icon className='pencil alternate' />
                        </Link>
                    } />
                    <Popup content={<Text tid='user_profile_delete_user' />} trigger={
                        <Icon 
                            onClick={() => setOpenModal(true)}
                            className='trash alternate'
                            style={{cursor: 'pointer'}}
                        />} />
                </Table.Cell>
            </Table.Row>
            <DeleteModal 
                openModal={openModal}
                setOpenModal={setOpenModal}
                handleDelete={handleDelete}
                getUsers={getUsers}
            />
            <Modal size='tiny' open={openRefreshModal} onClose={() => setOpenRefreshModal(!openRefreshModal)}>
                <Modal.Header><Text tid='user_profile_refresh_queries' /></Modal.Header>
                <Modal.Content>
                <Form.Input
                    value={queries || ''}
                    placeholder={Text({tid:'admin_user_queries'})}
                    name="queries" 
                    type="number"
                    onChange={handleChangeQueries}
                  />
                </Modal.Content>
                <Modal.Actions style={{display: 'flex'}}>
                    <Button className='lisia-blue' onClick={() => handleRefreshQueries(queries)}><Text tid='user_profile_add_queries' /></Button>
                    <Button className='lisia-blue' onClick={() => handleRefreshQueries(null)}><Text tid='user_profile_reset_queries' /></Button>
                    <Button negative onClick={() => setOpenRefreshModal(!openRefreshModal)}><Text tid='cancel' /></Button>
                </Modal.Actions>
        </Modal>
      </>
    )
}

export default UsersTableRow